var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 24.175,
    viewBox: "0 0 151 24.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(-1230 -5561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M27.3,11.743H18.748l-2.6-7.752a.941.941,0,0,0-1.767,0l-2.6,7.752H3.18a.933.933,0,0,0-.93.93.683.683,0,0,0,.017.157.893.893,0,0,0,.389.657l7.026,4.951-2.7,7.839a.932.932,0,0,0,.32,1.046.9.9,0,0,0,.523.227,1.139,1.139,0,0,0,.581-.209l6.857-4.887,6.857,4.887a1.089,1.089,0,0,0,.581.209.835.835,0,0,0,.517-.227.921.921,0,0,0,.32-1.046l-2.7-7.839,6.968-5,.169-.145a.975.975,0,0,0,.3-.622A.984.984,0,0,0,27.3,11.743Z",
    transform: "translate(1227.75 5557.625)",
    fill: "#fadb40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-2",
    "data-name": "Icon ionic-ios-star",
    d: "M27.3,11.743H18.748l-2.6-7.752a.941.941,0,0,0-1.767,0l-2.6,7.752H3.18a.933.933,0,0,0-.93.93.683.683,0,0,0,.017.157.893.893,0,0,0,.389.657l7.026,4.951-2.7,7.839a.932.932,0,0,0,.32,1.046.9.9,0,0,0,.523.227,1.139,1.139,0,0,0,.581-.209l6.857-4.887,6.857,4.887a1.089,1.089,0,0,0,.581.209.835.835,0,0,0,.517-.227.921.921,0,0,0,.32-1.046l-2.7-7.839,6.968-5,.169-.145a.975.975,0,0,0,.3-.622A.984.984,0,0,0,27.3,11.743Z",
    transform: "translate(1258.991 5557.625)",
    fill: "#fadb40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-3",
    "data-name": "Icon ionic-ios-star",
    d: "M27.3,11.743H18.748l-2.6-7.752a.941.941,0,0,0-1.767,0l-2.6,7.752H3.18a.933.933,0,0,0-.93.93.683.683,0,0,0,.017.157.893.893,0,0,0,.389.657l7.026,4.951-2.7,7.839a.932.932,0,0,0,.32,1.046.9.9,0,0,0,.523.227,1.139,1.139,0,0,0,.581-.209l6.857-4.887,6.857,4.887a1.089,1.089,0,0,0,.581.209.835.835,0,0,0,.517-.227.921.921,0,0,0,.32-1.046l-2.7-7.839,6.968-5,.169-.145a.975.975,0,0,0,.3-.622A.984.984,0,0,0,27.3,11.743Z",
    transform: "translate(1290.233 5557.625)",
    fill: "#fadb40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-4",
    "data-name": "Icon ionic-ios-star",
    d: "M27.3,11.743H18.748l-2.6-7.752a.941.941,0,0,0-1.767,0l-2.6,7.752H3.18a.933.933,0,0,0-.93.93.683.683,0,0,0,.017.157.893.893,0,0,0,.389.657l7.026,4.951-2.7,7.839a.932.932,0,0,0,.32,1.046.9.9,0,0,0,.523.227,1.139,1.139,0,0,0,.581-.209l6.857-4.887,6.857,4.887a1.089,1.089,0,0,0,.581.209.835.835,0,0,0,.517-.227.921.921,0,0,0,.32-1.046l-2.7-7.839,6.968-5,.169-.145a.975.975,0,0,0,.3-.622A.984.984,0,0,0,27.3,11.743Z",
    transform: "translate(1321.474 5557.625)",
    fill: "#fadb40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-5",
    "data-name": "Icon ionic-ios-star",
    d: "M27.3,11.743H18.748l-2.6-7.752a.941.941,0,0,0-1.767,0l-2.6,7.752H3.18a.933.933,0,0,0-.93.93.683.683,0,0,0,.017.157.893.893,0,0,0,.389.657l7.026,4.951-2.7,7.839a.932.932,0,0,0,.32,1.046.9.9,0,0,0,.523.227,1.139,1.139,0,0,0,.581-.209l6.857-4.887,6.857,4.887a1.089,1.089,0,0,0,.581.209.835.835,0,0,0,.517-.227.921.921,0,0,0,.32-1.046l-2.7-7.839,6.968-5,.169-.145a.975.975,0,0,0,.3-.622A.984.984,0,0,0,27.3,11.743Z",
    transform: "translate(1352.715 5557.625)",
    fill: "#fadb40"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.4bc5969a970b4f1ca01350d27447d43d.svg";
export { ForwardRef as ReactComponent };